var r = "-ms-", a = "-moz-", v = "-webkit-", E = "comm", e = "rule", m = "decl", M = "@import", T = "@keyframes";
export {
  E as COMMENT,
  m as DECLARATION,
  M as IMPORT,
  T as KEYFRAMES,
  a as MOZ,
  r as MS,
  e as RULESET,
  v as WEBKIT
};
//# sourceMappingURL=Enum.js.map
